
















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Counter } from '@/modules/backend/Entities/Counter';
import { namespace } from 'vuex-class';
import CounterItem from '@/components/counters/CounterItem.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import CounterAddDialog from '@/components/counters/CounterAddDialog.vue';

const CountersModule = namespace('dashboard/counters');

@Component({
  components: {
    'counter-add-dialog': CounterAddDialog,
    'counter-item': CounterItem,
    'data-table-wrapper': DataTableWrapper
  }
})
export default class CounterList extends Vue {
  @Prop({ required: true }) private readonly accountId!: number;

  @Prop({ type: Array, required: false }) private readonly resourcesIds: Array<number> | undefined;

  @CountersModule.Action('Fetch')
  private fetchCounters!: (accountId: string | number) => Promise<void>;

  @CountersModule.Getter('CountersByAccountId')
  private countersByAccountId!: (accountId: number) => Counter[];

  private loading = false;

  private get counters(): Counter[] {
    const counters = this.countersByAccountId(this.accountId);

    if (this.resourcesIds) {
      return (counters && counters.filter(
        (counter) => this.resourcesIds?.includes(counter.getResource().getId()))
      ) || [];
    }

    return counters || [];
  }

  private get hasCounters(): boolean {
    return this.counters && this.counters.length > 0;
  }

  private async updateCounters(): Promise<void> {
    this.loading = true;
    await this.fetchCounters(this.accountId);
    this.loading = false;
  }

  @Watch('accountId')
  private async accountIdChangeHandler(): Promise<void> {
    await this.updateCounters();
  }

  public async mounted(): Promise<void> {
    await this.updateCounters();
  }
}
